import "./Footer.css";
const Footer = () => {
    return (
        <div className="footer-container">
            <div className="footer-parent">
                <img src={require("../../assets/Home/shape-bg.png")} alt="404"/>
            </div>
        </div>
    )
}

export default Footer;